import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImportUsersForm } from './ImportUsersForm.jsx';
import {
  OuterSection,
  OuterSectionHeading,
  OuterSectionParagraph,
  StyledSection,
  SectionHeading,
  SectionParagraph,
  BulletPoint,
  StyledLink,
  StyledText,
  AirboEmail,
  TitleRow,
} from '../StyledComponents';
import { useGetUploadStatus } from '../../data';

const FileUploaded = ({ t }) => (
  <React.Fragment>
    <StyledText>{t('importUsers.uploadInProgress')}</StyledText>
    <StyledText>{t('importUsers.customerSuccessMessage')}</StyledText>
    <StyledText>
      {t('importUsers.anyQuestions')}
      <AirboEmail>{t('importUsers.airboEmail')}</AirboEmail>.
      {t('importUsers.thanks')}
    </StyledText>
  </React.Fragment>
);

const FileNotUploaded = ({ t }) => {
  return (
    <React.Fragment>
      <StyledSection style={{ paddingTop: 0 }}>
        <SectionHeading style={{ marginTop: 0 }}>
          {t('importUsers.stepOne')}
        </SectionHeading>
        <div style={{ display: 'flex' }}>
          <SectionParagraph>
            {t('importUsers.downloadTemplate')}
          </SectionParagraph>
          <SectionParagraph style={{ marginLeft: 'auto' }}>
            <StyledLink href={import.meta.env.VITE_ELIGIBLE_FILE_TEMPLATE}>
              {t('importUsers.downloadCsv')}
            </StyledLink>
          </SectionParagraph>
        </div>
      </StyledSection>
      <StyledSection>
        <SectionHeading>{t('importUsers.stepTwo')}</SectionHeading>
        <ul>
          <BulletPoint>{t('importUsers.addNames')}</BulletPoint>
          <BulletPoint>{t('importUsers.addEmail')}</BulletPoint>
          <BulletPoint>{t('importUsers.saveCsv')}</BulletPoint>
        </ul>
      </StyledSection>
      <StyledSection>
        <SectionHeading>{t('importUsers.stepThree')}</SectionHeading>
        <SectionParagraph>{t('importUsers.uploadCsv')}</SectionParagraph>
        <ImportUsersForm />
      </StyledSection>
    </React.Fragment>
  );
};

export const ImportUsers = () => {
  const { data } = useGetUploadStatus();
  const { t } = useTranslation('users');

  return (
    <OuterSection>
      <TitleRow>
        <OuterSectionHeading>
          {t('importUsers.importUsers')}
        </OuterSectionHeading>
        {data.demoData.last_added && (
          <OuterSectionParagraph>
            {t('importUsers.lastAdded')}
            {data.demoData.last_added}
          </OuterSectionParagraph>
        )}
      </TitleRow>
      {data.demoData.upload_in_progress ? (
        <FileUploaded t={t} />
      ) : (
        <FileNotUploaded t={t} />
      )}
    </OuterSection>
  );
};
